import { render, staticRenderFns } from "./Communidetil.vue?vue&type=template&id=9cd3a570&scoped=true&"
import script from "./Communidetil.vue?vue&type=script&lang=js&"
export * from "./Communidetil.vue?vue&type=script&lang=js&"
import style0 from "./Communidetil.vue?vue&type=style&index=0&id=9cd3a570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd3a570",
  null
  
)

export default component.exports